export enum PaymentMethodType {
  CARD = "CARD",
  PAYPAL = "PAYPAL",
}

export enum GooglePayCardNetwork {
  AMEX = "AMEX",
  DISCOVER = "DISCOVER",
  INTERAC = "INTERAC",
  JCB = "JCB",
  MASTERCARD = "MASTERCARD",
  VISA = "VISA",
}

export enum GooglePayCardAuthMethod {
  PAN_ONLY = "PAN_ONLY",
  CRYPTOGRAM_3DS = "CRYPTOGRAM_3DS",
}

export enum GooglePayTokenizationSpecificationType {
  PAYMENT_GATEWAY = "PAYMENT_GATEWAY",
  DIRECT = "DIRECT",
}

export enum GooglePayEnvironment {
  TEST = "TEST",
  PRODUCTION = "PRODUCTION",
}

export default class GooglePayMetadata {
  apiVersion: number;
  apiVersionMinor: number;
  paymentMethodType: PaymentMethodType;
  allowedCardNetworks: GooglePayCardNetwork[];
  allowedCardAuthMethods: GooglePayCardAuthMethod[];
  tokenizationSpecificationType: GooglePayTokenizationSpecificationType;
  gateway: string;
  gatewayMerchantId: string;
  googlePayMerchantId: string;
  merchantName: string;
  environment: GooglePayEnvironment;
}
